import type React from "react";
import { useState } from "react";
import { User } from "lucide-react";

interface LoginScreenProps {
    onLogin: (username: string, password: string) => void;
}

export const LoginScreen = ({ onLogin }: LoginScreenProps) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onLogin(username, password);
    };

    return (
        <div className="h-screen w-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-400 to-blue-600">
            <div className="flex flex-col items-center mb-8">
                <div className="w-24 h-24 rounded-full bg-gray-200 flex items-center justify-center mb-4">
                    <User className="w-16 h-16 text-gray-600" />
                </div>
                <h2 className="text-2xl font-semibold text-white mb-1">Welcome</h2>
                <p className="text-white text-opacity-80">Sign in to continue</p>
            </div>

            <form onSubmit={handleSubmit} className="w-80 bg-black bg-opacity-30 backdrop-blur-md p-6 rounded-lg">
                <div className="mb-4">
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Username"
                        className="w-full px-4 py-2 rounded bg-white bg-opacity-20 text-white placeholder-white placeholder-opacity-70 border border-white border-opacity-30 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>
                <div className="mb-6 relative">
                    <input
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        className="w-full px-4 py-2 rounded bg-white bg-opacity-20 text-white placeholder-white placeholder-opacity-70 border border-white border-opacity-30 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-3 top-2.5 text-white text-opacity-70">
                        {showPassword ? "Hide" : "Show"}
                    </button>
                </div>
                <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded transition-colors">
                    Sign in
                </button>
            </form>
        </div>
    );
};
